<template>
  <el-dialog :visible.sync="visible" width="450px">
    <h3 class="title">优惠券使用规则</h3>
    <p>1、每张优惠券有数量限制，先到先得；</p>
    <p>2、每位用户在领取时，每张优惠券有不同的领取次数限制；</p>
    <p>3、优惠券的使用必需满足其使用条件，包括单笔消费金额、适用项目(有“通”字样的优惠券表示：平台内所有项目通用)；</p>
    <p>4、优惠券有使用期限限制，必需在有效期内使用，过期即优惠券失效；</p>
    <p>5、每个订单只能使用一张优惠券；</p>
    <p>6、用户领取到的优惠券可以赠送给微信好友，在好友输入手机号并成功领取后，视为用户自己的优惠券成功赠送至好友名下；如果同一张优惠券同时赠送给多个好友，只有第一位领取成功的好友才有机会获得该优惠券；</p>
    <p>7、使用优惠券支付的订单，如果退货，优惠券抵扣金额不能退还，只能退还实际支付金额；</p>
  </el-dialog>
</template>

<script>
  export default {
    name: "coupons-rules-detail",
    data() {
      return {
        visible: false,
      }
    },
    methods: {
      init () {
        this.visible = true
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-dialog__body{
    padding: 0 20px 30px 20px;
  }
  h3.title{
    text-align: center;
    padding: 10px 0 20px 0;
  }
  .title{
    font-size: 18px;
    font-weight: bold;
  }
  p{
    line-height: 30px;
    text-indent: 2em
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/coupons-rules-detail.vue